/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import icon from "@assets/img/icon_validando_expediente.svg";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import TabBofu from "@components/TabBofu/TabBofu";

const ValidandoExpediente: React.FC = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <Box textAlign={"center"} mx={4}>
          <InactivityHandler />
          <Typography mt={4} mb={3} fontSize={"20px"} fontWeight={600} color={theme?.palette?.primary?.dark}>
            Faltantes en Expediente
          </Typography>

          <TabBofu />

          <Box sx={{ paddingTop: "2em" }}>
            <Typography fontWeight={300} color={theme?.palette?.primary?.dark} fontSize={"16px"}>
              Encontramos faltantes dentro de la validación, por favor ve a la sección o secciones marcadas con
              faltantes para resolverlos.
            </Typography>
          </Box>

          <Box sx={{ paddingTop: "3em" }}>
            <img src={icon} alt="icon" />
          </Box>

          <Box sx={{ paddingTop: "2em", paddingBottom: "1em" }}>
            <Typography fontWeight={300} color={theme?.palette?.primary?.dark} fontSize={"16px"}>
              Podría ser necesario el editar algunas secciones o volver a cargar algunos documentos.
            </Typography>
          </Box>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default ValidandoExpediente;
